import { render } from "./CreateCouponModal.vue?vue&type=template&id=8ec91e0a&scoped=true&ts=true"
import script from "./CreateCouponModal.vue?vue&type=script&lang=ts"
export * from "./CreateCouponModal.vue?vue&type=script&lang=ts"

import "./CreateCouponModal.vue?vue&type=style&index=0&id=8ec91e0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec91e0a"]])

export default __exports__